import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StatutIntervention } from 'src/api/models';

@Component({
  selector: 'app-intervention-statut',
  templateUrl: './intervention-statut.component.html',
  styleUrls: ['./intervention-statut.component.css']
})
export class InterventionStatutComponent implements OnInit {

  @Input('id') public id: number;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  GetInterventionStatut(s: StatutIntervention) {
    if (s === undefined) {
      return '';
    } else {
      return this.translateService.instant('Entretien.Interventions.Statuts.' + StatutIntervention[s]);
    }
  } 
}
